import { render, staticRenderFns } from "./BookGantt.vue?vue&type=template&id=2939e933&scoped=true&"
import script from "./BookGantt.vue?vue&type=script&lang=js&"
export * from "./BookGantt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2939e933",
  null
  
)

export default component.exports